import {useDispatch, useSelector} from 'react-redux';
import {useCallback} from 'react';
import {
  initAds,
  initLocation,
  initUtils,
  initPageSetting,
  setSelectedUtils,
  setSelectedScope,
  setLocationFilter,
  setCollapseJob,
  SendResumeData,
  updateLocationChecked,
  updateScopeChecked,
  updateAdsByFilter,
  saveSubmitData,
  updateScopeFalse,
  updateLocationFalse,
  getCities,
} from '../../CellcomCareersSlice'; // replace with the actual path

const useJob = () => {
  const dispatch = useDispatch();
  const {
    adsCareersData,
    utilsCareersData,
    pageCareersData,
    filterJobData,
    careerScopeList,
    locationCareersData,
    selectedUtils,
    locationsRegion,
    selectedScope,
    resumeJobStatus,
    submitData,
    buttonData,
    cities,
  } = useSelector((state) => state.cellcomCareers); // adjust the selector accordingly

  const memoziedInitCites = useCallback((payload) => dispatch(getCities()), [dispatch]);

  const memoizedInitAds = useCallback((payload) => dispatch(initAds(payload)), [dispatch]);

  const memoizedInitLocation = useCallback((payload) => dispatch(initLocation(payload)), [dispatch]);

  const memoizedInitUtils = useCallback((payload) => dispatch(initUtils(payload)), [dispatch]);

  const memoizedInitPageSetting = useCallback((payload) => dispatch(initPageSetting(payload)), [dispatch]);

  const memoizedSetSelectedUtils = useCallback((payload) => dispatch(setSelectedUtils(payload)), [dispatch]);

  const memoizedSetSelectedScope = useCallback((payload) => dispatch(setSelectedScope(payload)), [dispatch]);

  const memoizedSetLocationFilter = useCallback((payload) => dispatch(setLocationFilter(payload)), [dispatch]);

  const memoizedSetCollapseState = useCallback((data) => dispatch(setCollapseJob(data)), [dispatch]);

  const memoizedSendResumeData = useCallback((data) => dispatch(SendResumeData(data)), [dispatch]);
  const memoziedUpdateLocation = useCallback(
    (data) => {
      dispatch(updateLocationChecked(data));
    },
    [dispatch],
  );
  const memoziedUpdateScope = useCallback((data) => dispatch(updateScopeChecked(data)), [dispatch]);
  const memoziedUpdateAdsByFilter = useCallback((data) => dispatch(updateAdsByFilter(data)), [dispatch]);
  const memoziedSaveSubmitData = useCallback((data) => dispatch(saveSubmitData(data)), [dispatch]);
  const memoziedUpdateScopeFalse = useCallback((data) => dispatch(updateScopeFalse(data)), [dispatch]);
  const memoziedUpdateLocationFalse = useCallback((data) => dispatch(updateLocationFalse(data)), [dispatch]);

  return {
    pageCareersData,
    utilsCareersData,
    adsCareersData,
    filterJobData,
    careerScopeList,
    locationCareersData,
    selectedUtils,
    locationsRegion,
    selectedScope,
    cities,
    resumeJobStatus,
    submitData,
    buttonData,
    initAds: memoizedInitAds,
    initLocation: memoizedInitLocation,
    initUtils: memoizedInitUtils,
    initCities: memoziedInitCites,
    initPageSetting: memoizedInitPageSetting,
    setSelectedUtils: memoizedSetSelectedUtils,
    setSelectedScope: memoizedSetSelectedScope,
    setLocationFilter: memoizedSetLocationFilter,
    setCollapseState: memoizedSetCollapseState,
    sendResumeData: memoizedSendResumeData,
    updateLocation: memoziedUpdateLocation,
    updateScope: memoziedUpdateScope,
    updateAds: memoziedUpdateAdsByFilter,
    setSubmitData: memoziedSaveSubmitData,
    clearScopeFilter: memoziedUpdateScopeFalse,
    clearLocationFiler: memoziedUpdateLocationFalse,
  };
};

export default useJob;
